<div *ngIf="!isActiveSubscription" class="alert alert-warning show text-center" role="alert">
  <div class="message"><span>Votre abonnement n'est plus actif.</span>
    <span>Seul l'accès en consultation est autorisé.</span>
  </div>
  <button *ngIf="!isPageProfile" mat-flat-button color="primary" routerLink="/profile"
    [queryParams]="subscribeParams">Activer</button>
</div>